import { Portal } from '@bringg-frontend/bringg-web-infra';

import TrafficMatrixPage from './traffic-matrix-page';

export default function TraffixMatrixPortal() {
	return <Portal element={<TrafficMatrixPage />} nodeId="service-area-portal" />;
}
